import { render, staticRenderFns } from "./LetterIcon.vue?vue&type=template&id=f8180948&"
import script from "./LetterIcon.vue?vue&type=script&lang=ts&"
export * from "./LetterIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports